import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { SzChipRowOption } from './sz-chip-row-option.type';

@Component({
  selector: 'sz-chip-row',
  templateUrl: './sz-chip-row.component.html',
  styleUrls: ['./sz-chip-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzChipRowComponent<T> {
  readonly options: InputSignal<ReadonlyArray<SzChipRowOption<T>>> =
    input.required<ReadonlyArray<SzChipRowOption<T>>>();
  readonly value: InputSignal<T | null> = input<T | null>(null);
  readonly disabled: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly valueChange: EventEmitter<T> = new EventEmitter<T>();

  select(value: T): void {
    if (this.disabled()) {
      return;
    }
    this.valueChange.emit(value);
  }
}
